module.exports = __webpack_public_path__ + "static/media/author-2.2465b317.png";